'use client'

import { AntdRegistry } from '@ant-design/nextjs-registry'
import { ConfigProvider } from 'antd'
import { Amplify } from 'aws-amplify'
import mixpanel from 'mixpanel-browser'
import {
  PropsWithChildren,
  useEffect,
} from 'react'
import { Provider } from 'react-redux'

import {
  FAVORITE_EMOJIS,
  THEME,
} from '@/constants/local-storages'
import { menuConfig } from '@/constants/menu-config'
import { theme } from '@/constants/theme'
import { store } from '@/redux'
import { setFavoriteEmojis } from '@/redux/global'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'
import awsConfig from '@/utils/aws-config'
import { getMixpanelToken } from '@/utils/env'
import { init } from '@/utils/init'

function ProviderWithInitialization({ children }: PropsWithChildren) {
  const dispatch = useAppDispatch()
  const displayMode = useAppSelector((state) => state.global.displayMode)

  useEffect(() => {
    Amplify.configure(awsConfig)
    mixpanel.init(getMixpanelToken(), { autotrack: true })
    window.menuConfig = menuConfig
    void init(dispatch)
    const favoriteEmojisString = window.localStorage.getItem(FAVORITE_EMOJIS)
    if (favoriteEmojisString) {
      try {
        dispatch(setFavoriteEmojis(JSON.parse(favoriteEmojisString) as string[]))
      } catch (e) {
        console.error(e)
      }
    }
    const displayMode = window.localStorage.getItem(THEME)
    if (displayMode !== null) {
      try {
        // dispatch(setDisplayMode(displayMode as DisplayMode))
      } catch (e) {
        console.error(e)
      }
    }
  }, [dispatch])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', displayMode)
  }, [displayMode])

  return (
    <ConfigProvider theme={theme}>
      {children}
    </ConfigProvider>
  )
}

export default function ClientProvider({ children }: PropsWithChildren) {
  return (
    <Provider store={store}>
      <AntdRegistry>
        <ProviderWithInitialization>
          {children}
        </ProviderWithInitialization>
      </AntdRegistry>
    </Provider>
  )
}
